import axios from 'axios';
import { stringify } from 'querystring';
import {
  WORDPRESS_API_AJAX_PATH,
  WORDPRESS_API_EMAIL_SUBSCRIBE
} from '../constants';

const EMAIL_VALIDATION_REGEX = /^[\w!\\$&*\-=^`|~#%'+/?{}.]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const getEmailSubscribePath = (hostname) =>
  `https://${hostname}${WORDPRESS_API_AJAX_PATH}`;

export const isValidEmail = (email) =>
  EMAIL_VALIDATION_REGEX.test(email);

export const registerEmailSignUp = (data, wordpressApiHost) => new Promise((resolve, reject) => {
  const { email } = data;

  if (!email) {
    return reject({ message: 'No Email Address' });
  }

  if (!isValidEmail(email)) {
    return reject({ message: 'Invalid Email Address' });
  }

  data.action = WORDPRESS_API_EMAIL_SUBSCRIBE;

  return axios.post(getEmailSubscribePath(wordpressApiHost), stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    }
  })
    .then(function(response) {
      resolve(response);
    })
    .catch(function() {
      reject({ message: 'Oops! Something went wrong.' });
    });
});
